import { WORKSPACE_PADDING } from '@components/v2/constants';
import { Theme } from '@mui/material';
import { RACHEL_PANEL_WIDTH } from './components/RachelPanel/rachelPanel.styles';

export const RACHEL_SCROLLBAR_WIDTH = 4;

export const RACHEL_SCROLLBAR_INSET = 0.5;

export const getRachelDockedColumnWidth = (theme: Theme) =>
  `calc(${RACHEL_PANEL_WIDTH}px - ${theme.spacing(WORKSPACE_PADDING * 2)})`;
